import Select from 'react-select';
import styles from "./dealershipPicker.module.scss";
import { DealershipPickerProps } from '../../../../../interfaces/components';

const DealershipPicker = ({className, value, onChange, placeholder, options}: DealershipPickerProps) => {
    return(
        <Select
            value={value}
            onChange={(value) => onChange && onChange(value)}
            options={options}
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "#FCFCFC",
                    border: "1px solid rgba(0, 0, 0, 0.1215686275)",
                    borderRadius: "6px",
                    minWidth: "140px",
                    color: "#676767 !important",
                    fontSize: "14px",
                    fontWeight: "400"
                }),
                indicatorSeparator: () => ({
                    display: "none"
                }),
                option: (baseStyles, state) => ({
                    ...baseStyles,
                    ":hover": {backgroundColor: state.isSelected ? "#1A1C21" : "rgba(0, 0, 0, 0.2215686275)"},
                    "fontSize": "14px",
                    "cursor": "pointer"
                }),
                singleValue:(baseStyles, state) => ({
                    ...baseStyles,
                    color: "#676767",
                    fontWeight: "500",
                    fontSize: "14px"
                })
                
            }}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary: "#1A1C21",
                    primary75: "rgba(0, 0, 0, 0.7215686275)",
                    primary50: "rgba(0, 0, 0, 0.5215686275)",
                    primary25: "rgba(0, 0, 0, 0.2215686275)"
                }
            })}
            
            placeholder={<p className={styles.placeHolderSelect}>{placeholder}</p>}
            className={className}
        />
    )
}

export default DealershipPicker;